import { emptyArray } from 'ui-components/default-props/empty';

/*
 * Have to export this as a function from its own module so that
 * we can mock the implementation via Jest for certain tests that
 * require various seeded values here. The alternative would be
 * to dispatch the action creator functions that trigger updates
 * to this state, but then that also causes multiple render cycles
 * within hook functions when they're under test.
 */
export const getInitialState = () => ({
  columns: emptyArray,
  isResizing: false,
  leftoverColumnWidth: 0,
  resetToScrollTop: null,
  rowHovered: null,
});
